(function ($) {
	$(document).ready(function () {

		// Run the peek on load
		calcCardPeek();

		let debounce;

		// Run the peek on window resize
		$(window).on('resize', function () {

			//clear the delay if it's not finished yet
			if (debounce) {
				clearTimeout(debounce);
			}

			//start a new delay
			debounce = setTimeout(function () {
				//remove reference so another delay can start
				debounce = null;

				calcCardPeek();

			}, 200);
		});

		function calcCardPeek() {

			// For each hover column
			$.each($('.hover-column'), function () {

				$(".card-content-background", this).css("top", "");

				let cardHiddenContentHeight = $(".card-content-wrapper", this).height() - $(".card-title", this).height();

				$(".hover-column-card", this).css("--hover-column-hidden-content-height", cardHiddenContentHeight + "px");

			});
		}

	});
})(jQuery);